import { ComputeExpressionValue } from '../../../../expressions/compute/ComputeExpression';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { IEvaluationVariables } from '../../../../expressions/evaluate/variables/IEvaluationVariables';
import { formatIsoCalendarDate } from '../../inputs/date/formatIsoCalendarDate';

/**
 * Restituisce la stringa calcolata a partire dal valore dell'espressione.
 * Sostituisce tutte le variabili con il loro valore.
 */
export function hydrateComputedString(
  value: ComputeExpressionValue,
  variables: IEvaluationVariables,
) {
  return value
    .map(v => {
      // Caso standard: testo
      if (v.type === 'text') return v.text;

      // Riferimento a variabile
      if (!variables[v.attrs.reference.id]) return '';

      // Formattazione data
      if (v.attrs.reference.field.type === Datatype.Date) {
        return String(formatIsoCalendarDate(variables[v.attrs.reference.id]));
      }

      return String(variables[v.attrs.reference.id]);
    })
    .join('');
}
